
import Loading from '@/components/common/Loading'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import SchemaTags from "@/components/common/SchemaTags";
import React from 'react'



const Desktop = dynamic(() => import("@/components/outlet/FashionWatchesStore"), {
  loading: () => <Loading />
})

const Mobile = dynamic(() => import("@/components/outlet/FashionWatchesStoreMobile"), {
  loading: () => <Loading />
})


const FashionWatchesStore = ({mobileView}) => {
    return(
        <>
        <Head>
                <title> Fashion Watches Store | POS System for Fashion Watches</title>
                <link rel="canonical" href="https://queuebuster.co/outlet/fashion-watch-store-pos-billing-software" />
                <link rel="alternate" href="https://queuebuster.co/outlet/fashion-watch-store-pos-billing-software" hrefLang="en" />
                <meta name="description" content="Streamline your fashion watch store operations with QueueBuster’s POS Billing Software. Easily manage inventory and billing of fashion watches—all in one pos." />
                <meta property="og:title" content="Make Every Fashion Statement Seamless with QueueBuster’s Fashion Watch Store POS" />
                <meta property="og:description" content="Manage your fashion watch store like a pro! QueueBuster’s POS Billing Software simplifies billing, tracks inventory, and keeps your store running in perfect order." />
                <meta property="og:image" content="" />
                <meta property="og:url" content="https://queuebuster.co/outlet/fashion-watch-store-pos-billing-software" />
            </Head>
         <SchemaTags page="fashion-watch-store-pos-billing-software" />
          {mobileView ?  <Mobile/>: <Desktop/>}
        </>
    )
}


export default FashionWatchesStore